import React from 'react'

import cn from '../../../../commons/src/libs/class-names'

import fallbackSource from '../../../../commons/src/assets/images/model-thumbnail-fallback.svg'

import ImageContainer from '../../../../commons/src/components/image-container/image-container'

export interface Props {
  classNames?: string[]
  source?: string
  size?: 'default' | 's' | 'm' // default inherits size
  alt: string
  onClick?: React.MouseEventHandler
}

const ModelImage = ({classNames, source, size = 'default', alt, onClick}: Props) => (
  <div
    className={cn('ModelImage', {[`size-${size}`]: !!size, clickable: !!onClick}, classNames)}
    onClick={onClick}
  >
    <ImageContainer ratio="1-1" source={source} fallbackSource={fallbackSource} alt={alt} />
  </div>
)

export default ModelImage
